import { render, staticRenderFns } from "./seller-manage.vue?vue&type=template&id=39ab0cf0&scoped=true&"
import script from "./seller-manage.vue?vue&type=script&lang=js&"
export * from "./seller-manage.vue?vue&type=script&lang=js&"
import style0 from "./seller-manage.vue?vue&type=style&index=0&id=39ab0cf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab0cf0",
  null
  
)

export default component.exports